import {createSvgIcon} from '../create-svg-icon';

export const DoorFrontIcon = createSvgIcon(
  <path d="M19 19V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v14H3v2h18v-2h-2zm-2 0H7V5h10v14zm-4-8h2v2h-2v-2z" />
, 'DoorFrontOutlined');
